import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners} from '@angular/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MAT_ICON_DEFAULT_OPTIONS} from '@angular/material/icon'
import {provideRouter, withHashLocation} from '@angular/router'
import {ENVIRONMENT, LOCAL_STORAGE} from './0-general/providers'
import {authInterceptor} from './1-application/auth.interceptor'
import {responseInterceptor} from './1-application/response.interceptor'
import {routes} from './app.routes'
import {ConfigService} from './services/config.service'
import {environment} from '../environments/environment'

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: LOCAL_STORAGE, useValue: localStorage},
    {provide: ENVIRONMENT, useValue: environment},
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    ),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline'
      }
    },
    {provide: MAT_ICON_DEFAULT_OPTIONS, useValue: {fontSet: 'material-symbols-rounded'}}
  ]
}
